"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSetYOrientation = exports.useSetYOrientation = void 0;
var react_1 = require("react");
var _EXPORTS_1 = require("../../../../utils/_EXPORTS");
var useSetYOrientation = function (_a) {
    var showOptions = _a.showOptions, optionsRef = _a.optionsRef, relativeToRef = _a.relativeToRef, enabled = _a.enabled;
    var _b = (0, react_1.useState)("bottom"), yOrientation = _b[0], setYOrientation = _b[1];
    var _handleSetYOrientation = function () {
        if (!enabled)
            return;
        (0, exports.handleSetYOrientation)(optionsRef, relativeToRef, setYOrientation);
    };
    (0, _EXPORTS_1.useScroll)(_handleSetYOrientation, { detectScrollInAllDivs: true });
    (0, react_1.useLayoutEffect)(function () {
        if (showOptions) {
            _handleSetYOrientation(); //set y orientation
        }
    }, [showOptions]);
    return { yOrientation: yOrientation };
};
exports.useSetYOrientation = useSetYOrientation;
var handleSetYOrientation = function (elemRef, anchorRef, setYOrientation) {
    if (!anchorRef.current || !elemRef.current)
        return;
    // - - we calculate the bottom edge y pos of the options, if it opens downward
    var viewportHeight = window.innerHeight;
    var _a = anchorRef.current.getBoundingClientRect(), anchorPoint_YPos_BOTTOM = _a.bottom, anchorPoint_YPos_TOP = _a.top;
    var elemHeight = elemRef.current.getBoundingClientRect().height;
    var elemBottomEdge = anchorPoint_YPos_BOTTOM + elemHeight;
    // - - then we calculate the top edge y pos of the options, if it opens upward
    var elemTopEdge = anchorPoint_YPos_TOP - elemHeight;
    // - - if bottom is not popping out of the screen, set open downward (default)
    if (elemBottomEdge < viewportHeight) {
        setYOrientation("bottom");
    }
    // - - if both of them are popping out the screen, then set open downward (default)
    else if (elemBottomEdge >= viewportHeight && elemTopEdge <= 0) {
        setYOrientation("bottom");
    }
    // - - only one option left, bottom is popping out of screen, but top is NOT. so set open upward
    else {
        setYOrientation("top");
    }
};
exports.handleSetYOrientation = handleSetYOrientation;
